import { css } from 'styled-components';

const flexBasis = [20, 33, 50, 100]; // add values as needed

const generateFlexBasisClasses = () => {
  let styles = '';

  flexBasis.forEach((value) => (styles += `.flex-basis-${value} { flex-basis: ${value}%; }`));

  return css`
    ${styles}
  `;
};

const flex = css`
  .flex {
    display: flex;

    &- {
      &row {
        flex-direction: row;
      }

      &col {
        flex-direction: column;
      }

      &grow {
        flex-grow: 1;
      }

      &grow-0 {
        flex-grow: 0;
      }

      &align-center {
        align-items: center;
      }
    }
  }

  ${generateFlexBasisClasses()}
`;

export default flex;
